<div id="breadcrumb" class="general-structure-full-width" [class.header-is-fixed]="fixed">
  <div class="general-structure">
    <div class="content">
      <a routerLink="/home" [title]="'menu.home' | translate">
        <mat-icon svgIcon="home" class="home-icon-link"></mat-icon>
      </a>
      <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
        <ng-container *ngIf="!breadcrumb.hidden">
          @if (!last && breadcrumb.url && breadcrumb.navigable) {
          <mat-icon svgIcon="chevron-right" class="chevron-right-icon"></mat-icon>
          <a [routerLink]="breadcrumb.url" [title]="breadcrumb.label">
            <span class="link">{{breadcrumb.label}}</span>
          </a>
          } @else {
          <mat-icon svgIcon="chevron-right" class="chevron-right-icon"></mat-icon>
          <span class="truncate">{{ breadcrumb.label }}</span>
          }
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>